export type ClientRelationshipGroupParty = {
    gender: string | null;
    personMiddleNameProperCased: string | null;
    deceasedIndicator: string;
    personFirstNameProperCased: string | null;
    personLastNameProperCased: string | null;
    partyType: string;
    partnerIndicator: string | null;
    ulek: number;
    wmFullLegalEntityName: string;
    preferredName: string | null;
    birthDate: string | null;
};

export type ClientRelationshipGroup = {
    parties: ClientRelationshipGroupParty[];
    name: string | null;
    crgid: string | null;
    sourceSystem: string | null;
    sourceSystemId: string | null;
    activeFlag: string | null;
    createdDate: string | null;
    endDate: string | null;
};

export type ClientRelationshipGroupInformation = {
    clientRelationshipGroups: ClientRelationshipGroup[];
    name: string | null;
    rcid: string | null;
    sourceSystem: string | null;
    sourceSystemId: string | null;
    createdDate: string | null;
    endDate: string | null;
    isClientRelationshipGroupLocked: boolean;
    partners: ClientRelationshipGroupPartner[];
    ulek?: string | null
};

export type ClientRelationshipGroupPartner = {
    partnerCode: string;
    partnerName: string;
    phoneNumber: string | null;
    email: string | null;
    title: string | null;
};


export const clientRelationshipGroupInformationWithEmptyValues : ClientRelationshipGroupInformation = {
    clientRelationshipGroups: [],
    name: null,
    rcid: null,
    sourceSystem: null,
    sourceSystemId: null,
    createdDate: null,
    endDate: null,
    isClientRelationshipGroupLocked: false,
    partners: [],
    ulek: null
};

export const clientRelationshipGroupHierarchyTestMock : ClientRelationshipGroupInformation= {
    clientRelationshipGroups: [
        {
            parties: [
                {
                    gender: "F",
                    personMiddleNameProperCased: "K",
                    deceasedIndicator: "N",
                    personFirstNameProperCased: "Isabel",
                    personLastNameProperCased:"Brooks",
                    partyType: "PERS",
                    partnerIndicator: "N",
                    ulek: 1005358731,
                    wmFullLegalEntityName: "Isabel K Brooks",
                    preferredName: null,
                    birthDate: "1978-02-12"
                },
                {
                    gender: "M",
                    personMiddleNameProperCased: "J",
                    deceasedIndicator: "N",
                    personFirstNameProperCased: "Daniel",
                    personLastNameProperCased:"Brooks",
                    partyType: "PERS",
                    partnerIndicator: "Y",
                    ulek: 1005358732,
                    wmFullLegalEntityName: "Daniel J Brooks",
                    preferredName: "Dan",
                    birthDate: "1976-09-28"
                }
            ],
            name: "Brooks Family",
            crgid: "ee76d70b-009b-4605-b78c-7b735cbc1293",
            sourceSystem: "PWS",
            sourceSystemId: "PWS-1001",
            activeFlag: "Y",
            createdDate: "2025-01-15",
            endDate: null
        },
        {
            parties: [],
            name: null,
            crgid: "PG-1002",
            sourceSystem: "PWS",
            sourceSystemId: "PWS-1002",
            activeFlag: "N",
            createdDate: "2024-11-03",
            endDate: null
        }
    ],
    name: null,
    rcid: null,
    sourceSystem: null,
    sourceSystemId: null,
    createdDate: null,
    endDate: null,
    isClientRelationshipGroupLocked: false,
    partners: [
        {
            partnerCode: "partner03",
            partnerName: "Partner 03",
            phoneNumber: "33333333333",
            email: "partner03_example_com_invalid",
            title: "Wealth Advisor"
        },
        {
            partnerCode: "partner04",
            partnerName: "Partner 04",
            phoneNumber: "44444444444",
            email: "partner04_example_com_invalid",
            title: "Full Stack Engineer"
        }
    ]
};